<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    title="修改内容"
    :visible.sync="dialogFormVisible"
  >
    <el-form :model="editForm" :rules="formRules" ref="editForm">
      <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
        <el-select
          class="search-select"
          v-model="statuName"
          placeholder="请选择状态"
          @change="changeRole"
        >
          <el-option
            v-for="(item, index) in rolesList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="内容" :label-width="formLabelWidth" prop="message">
        <el-input v-model="editForm.message" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { setMyMsgApi } from '@/api/newsApi.js';
export default {
  name: 'myMsgAditForm',
  data() {
    return {
      formLabelWidth: '80px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      editForm: {},
      rolesList: [
        { label: '编辑中', value: 1 },
        { label: '已发布', value: 2 },
        { label: '已删除', value: 3 },
      ],
      statuName: '',
      formRules: {
        message: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
      },
    };
  },
  methods: {
    submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return;
        let nowTime = this.$moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
        let data =
          'myMsgId=' +
          this.editForm.myMsgId +
          '&userId=' +
          this.editForm.userId +
          '&status=' +
          this.editForm.status +
          '&message=' +
          this.editForm.message +
          '&sendTime=' +
          nowTime;
        let res = await setMyMsgApi(data);
        if (res.code !== 200) return;
        this.$message.success('修改成功!');
        this.dialogFormVisible = false;
        // 清空表单
        this.$refs['editForm'].resetFields();
        // 重新请求数据
        this.$emit('fetchData');
      });
    },

    // 点击状态下拉数据
    changeRole(val) {
      this.editForm.status = val;
    },
  },
};
</script>

<style></style>
